// Recommended Accessories - row toggle + safe PDP links (no price math)

class RecommendedAccessories {
  constructor() {
    this.container = document.querySelector('[data-recommended-accessories]');
    this.mainAddToCartButton = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    this.selectedAccessories = new Map();
    if (this.container) this.init();
  }

  init() {
    // Checkbox listeners
    this.container.querySelectorAll('.accessory-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e.target));
    });

    // Row click: toggle unless the click was on a link/interactive element
    this.container.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      if (e.target.closest('a, button, .accessory-checkbox, label')) return;

      const item = e.target.closest('[data-accessory-item]');
      if (!item) return;

      const cb = item.querySelector('.accessory-checkbox');
      if (!cb) return;

      cb.checked = !cb.checked;
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Add to Cart override: sequential adds
    if (this.mainAddToCartButton) {
      const form = this.mainAddToCartButton.closest('form');
      form.addEventListener('submit', async (e) => {
        if (this.selectedAccessories.size > 0) {
          e.preventDefault();
          await this.addToCartOptimizedSequential();
        }
      });
    }
  }

  handleCheckboxChange(checkbox) {
    const productId = checkbox.dataset.productId;
    const variantId = checkbox.dataset.variantId;
    const price = parseFloat(checkbox.dataset.price) / 100;

    if (checkbox.checked) this.selectedAccessories.set(productId, { variantId, price });
    else this.selectedAccessories.delete(productId);

    const item = checkbox.closest('[data-accessory-item]');
    if (item) item.classList.toggle('selected', checkbox.checked); // class-based styling (no inline borders)
  }

  clearAllSelections() {
    this.selectedAccessories.clear();
    this.container.querySelectorAll('.accessory-checkbox').forEach((cb) => {
      if (cb.checked) cb.checked = false;
      cb.closest('[data-accessory-item]')?.classList.remove('selected');
    });
  }

  async addToCartOptimizedSequential() {
    try {
      const form = this.mainAddToCartButton.closest('form');
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const mainQuantity = parseInt(formData.get('quantity')) || 1;

      // 1) Add main product
      const mainResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: mainVariantId, quantity: mainQuantity })
      });
      if (!mainResponse.ok) {
        alert('Error adding main product to cart');
        return;
      }

      // 2) Add accessories sequentially
      for (const [, accessory] of this.selectedAccessories) {
        await new Promise((r) => setTimeout(r, 25));
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: accessory.variantId, quantity: 1 })
        });
      }

      // 3) Clear and open drawer
      setTimeout(() => this.clearAllSelections(), 300);
      await new Promise((r) => setTimeout(r, 150));
      this.openCartDrawerFast();
    } catch {
      alert('Error adding items to cart. Please try again.');
    }
  }

  openCartDrawerFast() {
    try {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      setTimeout(() => document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')), 100);
      setTimeout(() => {
        const drawer = document.querySelector('#cart-drawer');
        const isOpen = drawer && (drawer.hasAttribute('open') || drawer.getAttribute('aria-hidden') === 'false');
        if (!isOpen) document.querySelector('.js-open-cart-drawer')?.click();
      }, 300);
    } catch {}
  }
}

// Init
new RecommendedAccessories();
